import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../common/Header';
import Hero from './Hero';
import ProtectionTypes from './ProtectionTypes';
import Commitment from './Commitment';
import Security from './Security';
import LockTypes from './LockTypes';
import Protection from './Protection';
import OrgFeatures from './OrgFeatures';
import BrowseSafes from './BrowseSafes';
import StickyNav from './StickyNav';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';
import Interrupter from "../../components/page/Interrupter";

class BuyingGuide extends Component {
	render() {
		return (
			<div className="buying-guide">
				<Helmet>
					<title>Learn About Our Safes | SentrySafe</title>
					<meta name="description" content="SentrySafe provides protection for the things that matter most to you. Learn more." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Learn" />
					<BreadcrumbItem label="Buying Guide" />
				</Breadcrumb>

				<StickyNav />

				<Interrupter bgColor="#FFCE00">
					<div className="text-center">
						<span className="font-weight-bold">Best-in-Class Fire Protection.</span> Our Newest Fireproof Safes are here. <a
						href="/learn/fire-and-water-safes" className="font-weight-bold" style={{color: '#2B2B2B', textDecoration: 'underline', marginLeft: '5px', display: 'inline-block'}}>Learn More ></a>
					</div>
				</Interrupter>

				<Header
					title="Learn about our safes"
					description="Protection for the things that matter to you."
				/>

				<Hero />
				
				<ProtectionTypes />

				<Commitment />
				
				<Security />
				
				<LockTypes />

				<Protection />
				
				<OrgFeatures />

				<BrowseSafes />
			</div>
		);
	}
};

export default BuyingGuide;


// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/Index.js